import script from "./messengerConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./messengerConfig.vue?vue&type=script&lang=ts&setup=true"

import "./messengerConfig.vue?vue&type=style&index=0&id=2b3883d5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b3883d5"]])

export default __exports__